var requireComponent = require.context('./', true, /\w+\.vue$/); //遍历当前目录和子目录

var comps = {};
requireComponent.keys().map(function (fileName) {
  var comp = requireComponent(fileName).default;
  comps[comp.name] = comp;
});
export default comps;